module.exports = __webpack_public_path__ + "static/preview-977f1cccc652fedb37d4a37ae052b0ff.jpg";